import { Button, IconName, Intent } from "@blueprintjs/core";
import React from "react";

import { ID } from "common/entities/IEntity";
import Class from "core/util/Class";
import IEntity from "core/util/IEntity";
import ServiceRegistry from "core/util/ServiceRegistry";


interface IDeleteButtonProps<T> {
	entity: Class<IEntity>;
	params: IEntity;
	onDeleted?: (id: ID) => void;
	onError?: (err: any) => void;
	label?: string | JSX.Element;
	minimal?: boolean;
	small?: boolean;
	intent?: Intent;
	icon?: IconName;
}

interface IDeleteButtonState {
	deleting: boolean;
}

export default class DeleteButton<T> extends React.PureComponent<IDeleteButtonProps<T>, IDeleteButtonState> {

	public state = { deleting: false };

	public render() {

		return (
			<Button
				loading={this.state.deleting}
				text={this.props.label || "Delete"}
				onClick={this.onClick}
				minimal={this.props.minimal}
				small={this.props.small}
				intent={this.props.intent}
				icon={this.props.icon}
			/>
		);
	}

	private onClick = () => {
		if (window.confirm('Are you sure you want to delete?')) {
			this.setState({deleting: true}, () => {
				ServiceRegistry
					.getMutationService()
					.delete(this.props.params, this.props.entity)
					.then((res) => {
						this.setState({deleting: false}, () => {
							if (typeof this.props.onDeleted === 'function') {
								this.props.onDeleted(res.entityId);
							}
						});
					})
					.catch((err) => {
						this.setState({deleting: false}, () => {
							if (typeof this.props.onError === 'function') {
								this.props.onError(err);
							}
						});
					});
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/components/DeleteButton.tsx